import { ValueTicker } from '@/app/elements/value-ticker/value-ticker';
import type { DailyJackpotPot } from '@/lib/daily-jackpots';
import { CountDownTimer } from '@/app/elements/countdown-timer/countdown-timer';
import {
    calculateTimeLeft,
    getTime,
    getTimeLeft12hFormat,
    getTimeLeftText
} from '@/utils/daily-jackpots/daily-jackpots-time';
import { getText } from '@/utils/text/text';
import { JACKPOT_STATE } from '@/utils/constants/daily-jackpots';

import './styles/@theme';

type DailyJackpotBadgeProps = {
    jackpot: DailyJackpotPot;
};

export const DailyJackpotBadge: React.FC<DailyJackpotBadgeProps> = ({ jackpot }) => {
    const { jackpotState } = jackpot;
    const isUrgentState = jackpotState === JACKPOT_STATE.URGENT;
    const isJustWonState = jackpotState === JACKPOT_STATE.JUST_WON;
    const { currentTime, hiddenTime, targetTime } = getTime(jackpot.time);
    const timeLeft = calculateTimeLeft({
        isJustWonState,
        currentTime,
        hiddenTime,
        targetTime
    });
    const timeLeftText = getTimeLeftText(timeLeft, true)?.replace(/(\d)\s*([a-zA-Z])/g, '$1$2');
    const timeLeft12hFormat = `${getText({
        text: 'components.timer.startsAt'
    })} ${getTimeLeft12hFormat(hiddenTime)}`;

    return (
        <div className={`daily-jackpot-badge${isUrgentState ? ' daily-jackpot-badge--urgent' : ''}`}>
            <img src={`/images/daily-jackpots-badge-logo-${process.env.BRAND}.png`} alt="daily-jackpot-logo" />
            <div className="text-container">
                <span className="amount">
                    {!isJustWonState ? (
                        <ValueTicker prevAmount={jackpot.prevAmount} amount={jackpot.amount} />
                    ) : (
                        <CountDownTimer
                            days={timeLeft?.days}
                            hours={timeLeft?.hours}
                            minutes={timeLeft?.minutes}
                            seconds={timeLeft?.seconds}
                        />
                    )}
                </span>
                <span className="remaining-time">{!isJustWonState ? timeLeftText : timeLeft12hFormat}</span>
            </div>
        </div>
    );
};
